import React from 'react';
import PropTypes from 'prop-types';

import FlagAT from '@bubble-ui/asset-flag-at';
import FlagAU from '@bubble-ui/asset-flag-au';
import FlagBE from '@bubble-ui/asset-flag-be';
import FlagCA from '@bubble-ui/asset-flag-ca';
import FlagCH from '@bubble-ui/asset-flag-ch';
import FlagCZ from '@bubble-ui/asset-flag-cz';
import FlagDE from '@bubble-ui/asset-flag-de';
import FlagDK from '@bubble-ui/asset-flag-dk';
import FlagES from '@bubble-ui/asset-flag-es';
import FlagFI from '@bubble-ui/asset-flag-fi';
import FlagFR from '@bubble-ui/asset-flag-fr';
import FlagGB from '@bubble-ui/asset-flag-gb';
import FlagGR from '@bubble-ui/asset-flag-gr';
import FlagHU from '@bubble-ui/asset-flag-hu';
import FlagIE from '@bubble-ui/asset-flag-ie';
import FlagIT from '@bubble-ui/asset-flag-it';
import FlagMX from '@bubble-ui/asset-flag-mx';
import FlagNL from '@bubble-ui/asset-flag-nl';
import FlagNO from '@bubble-ui/asset-flag-no';
import FlagNZ from '@bubble-ui/asset-flag-nz';
import FlagPL from '@bubble-ui/asset-flag-pl';
import FlagPT from '@bubble-ui/asset-flag-pt';
import FlagRO from '@bubble-ui/asset-flag-ro';
import FlagSE from '@bubble-ui/asset-flag-se';
import FlagSK from '@bubble-ui/asset-flag-sk';
import FlagUS from '@bubble-ui/asset-flag-us';

const mapping = {
  AT: FlagAT,
  AU: FlagAU,
  BE: FlagBE,
  CA: FlagCA,
  CH: FlagCH,
  CZ: FlagCZ,
  DE: FlagDE,
  DK: FlagDK,
  ES: FlagES,
  FI: FlagFI,
  FR: FlagFR,
  GB: FlagGB,
  GR: FlagGR,
  HU: FlagHU,
  IE: FlagIE,
  IT: FlagIT,
  MX: FlagMX,
  NL: FlagNL,
  NO: FlagNO,
  NZ: FlagNZ,
  PL: FlagPL,
  PT: FlagPT,
  RO: FlagRO,
  SE: FlagSE,
  SK: FlagSK,
  US: FlagUS,
};

export const Flag = ({ country, ...props }) => {
  const Flag = mapping[country.toUpperCase()];

  return Flag ? <Flag {...props} /> : null;
};

Flag.propTypes = {
  country: PropTypes.string.isRequired,
};
